import React from 'react';
import { ShoppingCart, CreditCard, User, Store, CheckCheck, Trash2 } from 'lucide-react';
import { toast } from 'sonner';
import { useApp } from '../context/AppContext';
import { PageHeader, Card } from './shared';
import { Button } from '@/components/ui/button';

const ICONS = { order: { icon: ShoppingCart, cls: 'bg-[#FDECEC] text-[#EE3B36]' }, payment: { icon: CreditCard, cls: 'bg-[#E8F0FE] text-[#2F80ED]' }, driver: { icon: User, cls: 'bg-[#E6F7F1] text-[#22A45D]' }, user: { icon: User, cls: 'bg-[#E6F7F1] text-[#22A45D]' }, restaurant: { icon: Store, cls: 'bg-[#FFF6E0] text-[#F08A00]' } };

const timeAgo = (iso) => {
  if (!iso) return '';
  const diff = Math.max(0, Date.now() - new Date(iso).getTime());
  const m = Math.floor(diff / 60000);
  if (m < 1) return 'Ahora'; if (m < 60) return `Hace ${m} min`;
  const h = Math.floor(m / 60); if (h < 24) return `Hace ${h} h`;
  return `Hace ${Math.floor(h / 24)} d`;
};

const AdminNotifications = () => {
  const { notifications, markAllRead, markRead, clearNotifications } = useApp();
  return (
    <div>
      <PageHeader title="Notificaciones" subtitle="Alertas de pedidos, pagos, conductores y restaurantes" actions={<><Button variant="outline" className="gap-2" onClick={() => markAllRead().then(() => toast.success('Todas marcadas como leídas'))}><CheckCheck size={16} /> Marcar todas leídas</Button><Button variant="outline" className="gap-2 text-red-600 border-red-200 hover:bg-red-50" onClick={() => clearNotifications().then(() => toast('Notificaciones eliminadas'))}><Trash2 size={16} /> Limpiar</Button></>} />
      <Card>
        <ul className="divide-y divide-gray-100">
          {notifications.length === 0 && <li className="text-center text-gray-400 py-16">No tienes notificaciones</li>}
          {notifications.map((n) => { const I = ICONS[n.type] || ICONS.order; return (
            <li key={n.id} data-testid={`notification-${n.id}`} onClick={() => !n.read && markRead(n.id)} className={`flex items-start gap-4 px-5 py-4 cursor-pointer transition-colors hover:bg-[#FAFAFB] ${n.read ? '' : 'bg-[#FFF7F7]'}`}>
              <div className={`w-11 h-11 rounded-xl flex items-center justify-center shrink-0 ${I.cls}`}><I.icon size={20} /></div>
              <div className="flex-1 min-w-0"><p className="font-semibold text-[#1E2130] flex items-center gap-2">{n.title}{!n.read && <span className="w-2 h-2 rounded-full bg-[#EE3B36]" />}</p><p className="text-sm text-gray-600">{n.desc}</p></div>
              <span className="text-xs text-gray-400 whitespace-nowrap">{timeAgo(n.createdAt)}</span>
            </li>); })}
        </ul>
      </Card>
    </div>
  );
};

export default AdminNotifications;
